import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { BehaviorSubject, catchError, map, Observable, throwError } from 'rxjs';
import { Aspirante, AspiranteDomicilio } from 'src/app/data/Aspirante';
import { CargoEleccionPopularAspirante } from 'src/app/data/CargoEleccionPopularAspirante';
import { ConocimientoElectoralAspirante } from 'src/app/data/ConocimientoElectoralAspirante';
import { DocumentosXAspirante } from 'src/app/data/DocumentosXAspirante';
import { EstudiosAspirante } from 'src/app/data/EstudiosAspirante';
import { OtrosDatosAspirante } from 'src/app/data/OtrosDatosAspirante';
import { ParticipacionCiudadanaAspirante } from 'src/app/data/ParticipacionCiudadanaAspirante';
import { PerfilAspirante } from 'src/app/data/PerfilAspirante';
import { PerfilCompletoAspirante } from 'src/app/data/PerfilCompletoAspirante';
import { PonenciaAspirante } from 'src/app/data/PonenciaAspirante';
import { PublicacionAspirante } from 'src/app/data/PublicacionAspirante';
import { ReconocimientoAspirante } from 'src/app/data/ReconocimientoAspirante';
import { TelefonoCorreoAspirante } from 'src/app/data/TelefonoCorreoAspirante';
import { TipoPropuestaAspirante } from 'src/app/data/TipoPropuestaAspirante';
import { TrayectoriaDocente } from 'src/app/data/TrayectoriaDocente';
import { TrayectoriaLaboral } from 'src/app/data/TrayectoriaLaboral';
import { TrayectoriaPolitica } from 'src/app/data/TrayectoriaPolitica';
import { VerificarCitaDocumentacionPerfil } from 'src/app/data/VerificarCitaDocumentacionPerfil';
import { ApiResponse } from 'src/app/shared/interfaces/apiResponse.interface';
import { BaseJwtService } from 'src/app/shared/services/base-jwt.service';
import { NotificationService } from 'src/app/shared/services/notification.service';

import { ActividadEmpresarialAspirante } from '../../../data/ActividadEmpresarialAspirante';

@Injectable({
  providedIn: 'root',
})
export class AspiranteService extends BaseJwtService {
  fechaFinConvocatoria: string;

  //BehaviorSubject
  private _aspiranteTieneCita = new BehaviorSubject<boolean>(false);
  private _tieneDocumentacionCompleta = new BehaviorSubject<boolean>(false);
  private _tienePerfilCompleto = new BehaviorSubject<boolean>(false);
  private _idEstatusPostulacionMunicipal = new BehaviorSubject<number>(0);
  private _idEstatusPostulacionDistrital = new BehaviorSubject<number>(0);

  public aspiranteTieneCita$ = this._aspiranteTieneCita.asObservable();
  public tieneDocumentacionCompleta$ =
    this._tieneDocumentacionCompleta.asObservable();
  public tienePerfilCompleto$ = this._tienePerfilCompleto.asObservable();
  public idEstatusPostulacionMunicipal$ =
    this._idEstatusPostulacionMunicipal.asObservable();
  public idEstatusPostulacionDistrital$ =
    this._idEstatusPostulacionDistrital.asObservable();

  constructor(
    protected _http: HttpClient,
    protected _notificationService: NotificationService,
    protected _jwtHelper: JwtHelperService,
    protected _router: Router
  ) {
    super(_http, _notificationService, _jwtHelper, _router);
  }

  actualizarAspiranteTieneCita(valor: boolean) {
    this._aspiranteTieneCita.next(valor);
  }

  actualizarTieneDocumentacionCompleta(valor: boolean) {
    this._tieneDocumentacionCompleta.next(valor);
  }

  actualizarTienePerfilCompleto(valor: boolean) {
    this._tienePerfilCompleto.next(valor);
  }

  actualizarIdEstatusPostulacionMunicipal(valor: number) {
    this._idEstatusPostulacionMunicipal.next(valor);
  }

  actualizarIdEstatusPostulacionDistrital(valor: number) {
    this._idEstatusPostulacionDistrital.next(valor);
  }

  verificarCitaDocumentacionPerfil(
    id: string
  ): Observable<ApiResponse<VerificarCitaDocumentacionPerfil>> {
    return this._http
      .get<ApiResponse<VerificarCitaDocumentacionPerfil>>(
        `${this.api}/aspirantes/verificarCitaDocumentacionPerfil/${id}`,
        this.httpOptionsJwt()
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  obtenerDatosGrales(id: string): Observable<ApiResponse<Aspirante>> {
    return this._http
      .get<ApiResponse<Aspirante>>(
        `${this.api}/aspirantes/${id}/generales`,
        this.httpOptionsJwt()
      )
      .pipe(
        map((response) => {
          if (response.exito) {
            return response;
          } else {
            this._notificationService.error(response.mensaje);
            throw new Error(response.mensaje);
          }
        }),
        catchError((error) => {
          if (error.status == 405) {
            this._notificationService.error(error.message);
          } else if (error.status === 422) {
            this._notificationService.error(error.error.mensaje);
          }
          console.log(error);
          return throwError(error);
        })
      );
  }

  obtenerDetalleCompletoAspirante(
    id: string
  ): Observable<ApiResponse<PerfilAspirante>> {
    return this._http
      .get<ApiResponse<PerfilAspirante>>(
        `${this.api}/aspirantes/${id}/completo`,
        this.httpOptionsJwt()
      )
      .pipe(
        map((response) => {
          if (response.exito) {
            return response;
          } else {
            this._notificationService.error(response.mensaje);
            throw new Error(response.mensaje);
          }
        }),
        catchError((error) => {
          this._notificationService.error(error.error.mensaje);
          return throwError(error);
        })
      );
  }

  obtenerDatosParciales(id: string): Observable<ApiResponse<Aspirante>> {
    return this._http
      .get<ApiResponse<Aspirante>>(
        `${this.api}/aspirantes/${id}/parcial`,
        this.httpOptionsJwt()
      )
      .pipe(
        map((response) => {
          if (response.exito) {
            return response;
          } else {
            this._notificationService.error(response.mensaje);
            throw new Error(response.mensaje);
          }
        }),
        catchError((error) => {
          if (error.status == 405) {
            this._notificationService.error(error.message);
          } else if (error.status === 422) {
            this._notificationService.error(error.error.mensaje);
          }
          console.log(error);
          return throwError(error);
        })
      );
  }

  obtenerDomicilio(id: string): Observable<ApiResponse<Aspirante>> {
    return this._http
      .get<ApiResponse<Aspirante>>(
        `${this.api}/aspirantes/${id}/domicilio`,
        this.httpOptionsJwt()
      )
      .pipe(
        map((response) => {
          if (response.exito) {
            return response;
          } else {
            this._notificationService.error(response.mensaje);
            throw new Error(response.mensaje);
          }
        }),
        catchError((error) => {
          if (error.status == 405) {
            this._notificationService.error(error.message);
          } else if (error.status === 422) {
            this._notificationService.error(error.error.mensaje);
          }
          console.log(error);
          return throwError(error);
        })
      );
  }

  obtenerTelefonos(id: string): Observable<ApiResponse<Aspirante>> {
    return this._http
      .get<ApiResponse<Aspirante>>(
        `${this.api}/aspirantes/${id}/telefonos`,
        this.httpOptionsJwt()
      )
      .pipe(
        map((response) => {
          if (response.exito) {
            return response;
          } else {
            this._notificationService.error(response.mensaje);
            throw new Error(response.mensaje);
          }
        }),
        catchError((error) => {
          if (error.status == 405) {
            this._notificationService.error(error.message);
          } else if (error.status === 422) {
            this._notificationService.error(error.error.mensaje);
          }
          console.log(error);
          return throwError(error);
        })
      );
  }

  obtenerEstudios(id: string): Observable<ApiResponse<EstudiosAspirante>> {
    return this._http
      .get<ApiResponse<EstudiosAspirante>>(
        `${this.api}/aspirantes/${id}/estudios`,
        this.httpOptionsJwt()
      )
      .pipe(
        map((response) => {
          if (response.exito) {
            return response;
          } else {
            this._notificationService.error(response.mensaje);
            throw new Error(response.mensaje);
          }
        }),
        catchError((error) => {
          if (error.status == 405) {
            this._notificationService.error(error.message);
          } else if (error.status === 422) {
            this._notificationService.error(error.error.mensaje);
          }
          console.log(error);
          return throwError(error);
        })
      );
  }

  actualizarEstudios(
    estudios: EstudiosAspirante,
    id: string
  ): Observable<ApiResponse<EstudiosAspirante>> {
    return this._http
      .put<ApiResponse<EstudiosAspirante>>(
        `${this.api}/aspirantes/${id}/estudios`,
        JSON.stringify(estudios),
        this.httpOptionsJwt()
      )
      .pipe(
        map((response) => {
          if (response.exito) {
            this._notificationService.success(response.mensaje);
            return response;
          } else {
            this._notificationService.error(response.mensaje);
            throw new Error(response.mensaje);
          }
        }),
        catchError((error) => {
          this._notificationService.error(error.error.mensaje);
          return throwError(error);
        })
      );
  }

  obtenerTrayectoriasDocentes(
    id: string
  ): Observable<ApiResponse<Array<TrayectoriaDocente>>> {
    return this._http
      .get<ApiResponse<Array<TrayectoriaDocente>>>(
        `${this.api}/aspirantes/${id}/trayectorias/docentes`,
        this.httpOptionsJwt()
      )
      .pipe(
        map((response) => {
          if (response.exito) {
            return response;
          } else {
            this._notificationService.error(response.mensaje);
            throw new Error(response.mensaje);
          }
        }),
        catchError((error) => {
          if (error.status == 405) {
            this._notificationService.error(error.message);
          } else if (error.status === 422) {
            this._notificationService.error(error.error.mensaje);
          }
          console.log(error);
          return throwError(error);
        })
      );
  }

  actualizarTrayectoriasDocentes(
    trayectorias: TrayectoriaDocente[],
    id: string
  ): Observable<ApiResponse<TrayectoriaDocente[]>> {
    return this._http
      .put<ApiResponse<TrayectoriaDocente[]>>(
        `${this.api}/aspirantes/${id}/trayectorias/docentes`,
        JSON.stringify(trayectorias),
        this.httpOptionsJwt()
      )
      .pipe(
        map((response) => {
          if (response.exito) {
            this._notificationService.success(response.mensaje);
            return response;
          } else {
            this._notificationService.error(response.mensaje);
            throw new Error(response.mensaje);
          }
        }),
        catchError((error) => {
          this._notificationService.error(error.error.mensaje);
          return throwError(error);
        })
      );
  }

  obtenerConocimientosElectorales(
    id: string
  ): Observable<ApiResponse<Array<ConocimientoElectoralAspirante>>> {
    return this._http
      .get<ApiResponse<Array<ConocimientoElectoralAspirante>>>(
        `${this.api}/aspirantes/${id}/conocimientos/electorales`,
        this.httpOptionsJwt()
      )
      .pipe(
        map((response) => {
          if (response.exito) {
            return response;
          } else {
            this._notificationService.error(response.mensaje);
            throw new Error(response.mensaje);
          }
        }),
        catchError((error) => {
          if (error.status == 405) {
            this._notificationService.error(error.message);
          } else if (error.status === 422) {
            this._notificationService.error(error.error.mensaje);
          }
          console.log(error);
          return throwError(error);
        })
      );
  }

  actualizarConocimientosElectorales(
    conocimientos: ConocimientoElectoralAspirante[],
    id: string
  ): Observable<ApiResponse<ConocimientoElectoralAspirante[]>> {
    return this._http
      .put<ApiResponse<ConocimientoElectoralAspirante[]>>(
        `${this.api}/aspirantes/${id}/conocimientos/electorales`,
        JSON.stringify(conocimientos),
        this.httpOptionsJwt()
      )
      .pipe(
        map((response) => {
          if (response.exito) {
            this._notificationService.success(response.mensaje);
            return response;
          } else {
            this._notificationService.error(response.mensaje);
            throw new Error(response.mensaje);
          }
        }),
        catchError((error) => {
          this._notificationService.error(error.error.mensaje);
          return throwError(error);
        })
      );
  }

  obtenerTrayectoriasLaborales(
    id: string
  ): Observable<ApiResponse<Array<TrayectoriaLaboral>>> {
    return this._http
      .get<ApiResponse<Array<TrayectoriaLaboral>>>(
        `${this.api}/aspirantes/${id}/trayectorias/laborales`,
        this.httpOptionsJwt()
      )
      .pipe(
        map((response) => {
          if (response.exito) {
            return response;
          } else {
            this._notificationService.error(response.mensaje);
            throw new Error(response.mensaje);
          }
        }),
        catchError((error) => {
          if (error.status == 405) {
            this._notificationService.error(error.message);
          } else if (error.status === 422) {
            this._notificationService.error(error.error.mensaje);
          }
          return throwError(error);
        })
      );
  }

  actualizarTrayectoriasLaborales(
    trayectorias: TrayectoriaLaboral[],
    id: string
  ): Observable<ApiResponse<TrayectoriaLaboral[]>> {
    return this._http
      .put<ApiResponse<TrayectoriaLaboral[]>>(
        `${this.api}/aspirantes/${id}/trayectorias/laborales`,
        JSON.stringify(trayectorias),
        this.httpOptionsJwt()
      )
      .pipe(
        map((response) => {
          if (response.exito) {
            this._notificationService.success(response.mensaje);
            return response;
          } else {
            this._notificationService.error(response.mensaje);
            throw new Error(response.mensaje);
          }
        }),
        catchError((error) => {
          this._notificationService.error(error.error.mensaje);
          return throwError(error);
        })
      );
  }

  obtenerTrayectoriasPoliticas(
    id: string
  ): Observable<ApiResponse<Array<TrayectoriaPolitica>>> {
    return this._http
      .get<ApiResponse<Array<TrayectoriaPolitica>>>(
        `${this.api}/aspirantes/${id}/trayectorias/politicas`,
        this.httpOptionsJwt()
      )
      .pipe(
        map((response) => {
          if (response.exito) {
            return response;
          } else {
            this._notificationService.error(response.mensaje);
            throw new Error(response.mensaje);
          }
        }),
        catchError((error) => {
          if (error.status == 405) {
            this._notificationService.error(error.message);
          } else if (error.status === 422) {
            this._notificationService.error(error.error.mensaje);
          }
          console.log(error);
          return throwError(error);
        })
      );
  }

  actualizarTrayectoriasPoliticas(
    trayectorias: TrayectoriaPolitica[],
    id: string
  ): Observable<ApiResponse<TrayectoriaPolitica[]>> {
    return this._http
      .put<ApiResponse<TrayectoriaPolitica[]>>(
        `${this.api}/aspirantes/${id}/trayectorias/politicas`,
        JSON.stringify(trayectorias),
        this.httpOptionsJwt()
      )
      .pipe(
        map((response) => {
          if (response.exito) {
            this._notificationService.success(response.mensaje);
            return response;
          } else {
            this._notificationService.error(response.mensaje);
            throw new Error(response.mensaje);
          }
        }),
        catchError((error) => {
          this._notificationService.error(error.error.mensaje);
          return throwError(error);
        })
      );
  }

  obtenerPublicaciones(
    id: string
  ): Observable<ApiResponse<Array<PublicacionAspirante>>> {
    return this._http
      .get<ApiResponse<Array<PublicacionAspirante>>>(
        `${this.api}/aspirantes/${id}/publicaciones`,
        this.httpOptionsJwt()
      )
      .pipe(
        map((response) => {
          if (response.exito) {
            return response;
          } else {
            this._notificationService.error(response.mensaje);
            throw new Error(response.mensaje);
          }
        }),
        catchError((error) => {
          if (error.status == 405) {
            this._notificationService.error(error.message);
          } else if (error.status === 422) {
            this._notificationService.error(error.error.mensaje);
          }
          console.log(error);
          return throwError(error);
        })
      );
  }

  actualizarPublicaciones(
    publicaciones: PublicacionAspirante[],
    id: string
  ): Observable<ApiResponse<PublicacionAspirante[]>> {
    return this._http
      .put<ApiResponse<PublicacionAspirante[]>>(
        `${this.api}/aspirantes/${id}/publicaciones`,
        JSON.stringify(publicaciones),
        this.httpOptionsJwt()
      )
      .pipe(
        map((response) => {
          if (response.exito) {
            this._notificationService.success(response.mensaje);
            return response;
          } else {
            this._notificationService.error(response.mensaje);
            throw new Error(response.mensaje);
          }
        }),
        catchError((error) => {
          this._notificationService.error(error.error.mensaje);
          return throwError(error);
        })
      );
  }

  obtenerPonencias(
    id: string
  ): Observable<ApiResponse<Array<PonenciaAspirante>>> {
    return this._http
      .get<ApiResponse<Array<PonenciaAspirante>>>(
        `${this.api}/aspirantes/${id}/ponencias`,
        this.httpOptionsJwt()
      )
      .pipe(
        map((response) => {
          if (response.exito) {
            return response;
          } else {
            this._notificationService.error(response.mensaje);
            throw new Error(response.mensaje);
          }
        }),
        catchError((error) => {
          if (error.status == 405) {
            this._notificationService.error(error.message);
          } else if (error.status === 422) {
            this._notificationService.error(error.error.mensaje);
          }
          console.log(error);
          return throwError(error);
        })
      );
  }

  actualizarPonencias(
    ponencias: PonenciaAspirante[],
    id: string
  ): Observable<ApiResponse<PonenciaAspirante[]>> {
    return this._http
      .put<ApiResponse<PonenciaAspirante[]>>(
        `${this.api}/aspirantes/${id}/ponencias`,
        JSON.stringify(ponencias),
        this.httpOptionsJwt()
      )
      .pipe(
        map((response) => {
          if (response.exito) {
            this._notificationService.success(response.mensaje);
            return response;
          } else {
            this._notificationService.error(response.mensaje);
            throw new Error(response.mensaje);
          }
        }),
        catchError((error) => {
          this._notificationService.error(error.error.mensaje);
          return throwError(error);
        })
      );
  }

  obtenerActividadEmpresarial(
    id: string
  ): Observable<ApiResponse<Array<ActividadEmpresarialAspirante>>> {
    return this._http
      .get<ApiResponse<Array<ActividadEmpresarialAspirante>>>(
        `${this.api}/aspirantes/${id}/actividad/empresarial`,
        this.httpOptionsJwt()
      )
      .pipe(
        map((response) => {
          if (response.exito) {
            return response;
          } else {
            this._notificationService.error(response.mensaje);
            throw new Error(response.mensaje);
          }
        }),
        catchError((error) => {
          if (error.status == 405) {
            this._notificationService.error(error.message);
          } else if (error.status === 422) {
            this._notificationService.error(error.error.mensaje);
          }
          console.log(error);
          return throwError(error);
        })
      );
  }

  actualizarActividadesEmpresariales(
    actividades: ActividadEmpresarialAspirante[],
    id: string
  ): Observable<ApiResponse<ActividadEmpresarialAspirante[]>> {
    return this._http
      .put<ApiResponse<ActividadEmpresarialAspirante[]>>(
        `${this.api}/aspirantes/${id}/actividad/empresarial`,
        JSON.stringify(actividades),
        this.httpOptionsJwt()
      )
      .pipe(
        map((response) => {
          if (response.exito) {
            this._notificationService.success(response.mensaje);
            return response;
          } else {
            this._notificationService.error(response.mensaje);
            throw new Error(response.mensaje);
          }
        }),
        catchError((error) => {
          this._notificationService.error(error.error.mensaje);
          return throwError(error);
        })
      );
  }

  obtenerCargosEleccion(
    id: string
  ): Observable<ApiResponse<Array<CargoEleccionPopularAspirante>>> {
    return this._http
      .get<ApiResponse<Array<CargoEleccionPopularAspirante>>>(
        `${this.api}/aspirantes/${id}/cargos/eleccion`,
        this.httpOptionsJwt()
      )
      .pipe(
        map((response) => {
          if (response.exito) {
            return response;
          } else {
            this._notificationService.error(response.mensaje);
            throw new Error(response.mensaje);
          }
        }),
        catchError((error) => {
          if (error.status == 405) {
            this._notificationService.error(error.message);
          } else if (error.status === 422) {
            this._notificationService.error(error.error.mensaje);
          }
          console.log(error);
          return throwError(error);
        })
      );
  }

  actualizarCargosEleccion(
    cargos: CargoEleccionPopularAspirante[],
    id: string
  ): Observable<ApiResponse<CargoEleccionPopularAspirante[]>> {
    return this._http
      .put<ApiResponse<CargoEleccionPopularAspirante[]>>(
        `${this.api}/aspirantes/${id}/cargos/eleccion`,
        JSON.stringify(cargos),
        this.httpOptionsJwt()
      )
      .pipe(
        map((response) => {
          if (response.exito) {
            this._notificationService.success(response.mensaje);
            return response;
          } else {
            this._notificationService.error(response.mensaje);
            throw new Error(response.mensaje);
          }
        }),
        catchError((error) => {
          this._notificationService.error(error.error.mensaje);
          return throwError(error);
        })
      );
  }

  obtenerParticipacionesCiudadanas(
    id: string
  ): Observable<ApiResponse<Array<ParticipacionCiudadanaAspirante>>> {
    return this._http
      .get<ApiResponse<Array<ParticipacionCiudadanaAspirante>>>(
        `${this.api}/aspirantes/${id}/participacion/ciudadana`,
        this.httpOptionsJwt()
      )
      .pipe(
        map((response) => {
          if (response.exito) {
            return response;
          } else {
            this._notificationService.error(response.mensaje);
            throw new Error(response.mensaje);
          }
        }),
        catchError((error) => {
          if (error.status == 405) {
            this._notificationService.error(error.message);
          } else if (error.status === 422) {
            this._notificationService.error(error.error.mensaje);
          }
          console.log(error);
          return throwError(error);
        })
      );
  }

  actualizarParticipacionesCiudadanas(
    cargos: ParticipacionCiudadanaAspirante[],
    id: string
  ): Observable<ApiResponse<ParticipacionCiudadanaAspirante[]>> {
    return this._http
      .put<ApiResponse<ParticipacionCiudadanaAspirante[]>>(
        `${this.api}/aspirantes/${id}/participacion/ciudadana`,
        JSON.stringify(cargos),
        this.httpOptionsJwt()
      )
      .pipe(
        map((response) => {
          if (response.exito) {
            this._notificationService.success(response.mensaje);
            return response;
          } else {
            this._notificationService.error(response.mensaje);
            throw new Error(response.mensaje);
          }
        }),
        catchError((error) => {
          this._notificationService.error(error.error.mensaje);
          return throwError(error);
        })
      );
  }

  obtenerReconocimientos(
    id: string
  ): Observable<ApiResponse<Array<ReconocimientoAspirante>>> {
    return this._http
      .get<ApiResponse<Array<ReconocimientoAspirante>>>(
        `${this.api}/aspirantes/${id}/reconocimientos`,
        this.httpOptionsJwt()
      )
      .pipe(
        map((response) => {
          if (response.exito) {
            return response;
          } else {
            this._notificationService.error(response.mensaje);
            throw new Error(response.mensaje);
          }
        }),
        catchError((error) => {
          if (error.status == 405) {
            this._notificationService.error(error.message);
          } else if (error.status === 422) {
            this._notificationService.error(error.error.mensaje);
          }
          console.log(error);
          return throwError(error);
        })
      );
  }

  obtenerTiposPropuesta(
    id: string
  ): Observable<ApiResponse<TipoPropuestaAspirante>> {
    return this._http
      .get<ApiResponse<TipoPropuestaAspirante>>(
        `${this.api}/aspirantes/${id}/tipo-propuesta`,
        this.httpOptionsJwt()
      )
      .pipe(
        map((response) => {
          if (response.exito) {
            return response;
          } else {
            this._notificationService.error(response.mensaje);
            throw new Error(response.mensaje);
          }
        }),
        catchError((error) => {
          if (error.status == 405) {
            this._notificationService.error(error.message);
          } else if (error.status === 422) {
            this._notificationService.error(error.error.mensaje);
          }
          console.log(error);
          return throwError(error);
        })
      );
  }

  obtenerOtrosDatos(id: string): Observable<ApiResponse<OtrosDatosAspirante>> {
    return this._http
      .get<ApiResponse<OtrosDatosAspirante>>(
        `${this.api}/aspirantes/${id}/otros-datos`,
        this.httpOptionsJwt()
      )
      .pipe(
        map((response) => {
          if (response.exito) {
            return response;
          } else {
            this._notificationService.error(response.mensaje);
            throw new Error(response.mensaje);
          }
        }),
        catchError((error) => {
          if (error.status == 405) {
            this._notificationService.error(error.message);
          } else if (error.status === 422) {
            this._notificationService.error(error.error.mensaje);
          }
          console.log(error);
          return throwError(error);
        })
      );
  }

  actualizarReconocimientos(
    cargos: ReconocimientoAspirante[],
    id: string
  ): Observable<ApiResponse<ReconocimientoAspirante[]>> {
    return this._http
      .put<ApiResponse<ReconocimientoAspirante[]>>(
        `${this.api}/aspirantes/${id}/reconocimientos`,
        JSON.stringify(cargos),
        this.httpOptionsJwt()
      )
      .pipe(
        map((response) => {
          if (response.exito) {
            this._notificationService.success(response.mensaje);
            return response;
          } else {
            this._notificationService.error(response.mensaje);
            throw new Error(response.mensaje);
          }
        }),
        catchError((error) => {
          this._notificationService.error(error.error.mensaje);
          return throwError(error);
        })
      );
  }

  actualizarDatosPersonales(
    aspirante: Aspirante,
    id: string
  ): Observable<ApiResponse<Aspirante>> {
    return this._http
      .put<ApiResponse<Aspirante>>(
        `${this.api}/aspirantes/${id}/personales`,
        JSON.stringify(aspirante),
        this.httpOptionsJwt()
      )
      .pipe(
        map((response) => {
          if (response.exito) {
            this._notificationService.success(response.mensaje);
            return response;
          } else {
            this._notificationService.error(response.mensaje);
            throw new Error(response.mensaje);
          }
        }),
        catchError((error) => {
          this._notificationService.error(error.error.mensaje);
          return throwError(error);
        })
      );
  }

  actualizarDomicilio(
    aspirante: AspiranteDomicilio,
    id: string
  ): Observable<ApiResponse<Aspirante>> {
    return this._http
      .put<ApiResponse<Aspirante>>(
        `${this.api}/aspirantes/${id}/domicilio`,
        JSON.stringify(aspirante),
        this.httpOptionsJwt()
      )
      .pipe(
        map((response) => {
          if (response.exito) {
            this._notificationService.success(response.mensaje);
            return response;
          } else {
            this._notificationService.error(response.mensaje);
            throw new Error(response.mensaje);
          }
        }),
        catchError((error) => {
          this._notificationService.error(error.error.mensaje);
          return throwError(error);
        })
      );
  }

  actualizarTelefonos(
    telefonos: TelefonoCorreoAspirante,
    id: string
  ): Observable<ApiResponse<TelefonoCorreoAspirante>> {
    return this._http
      .put<ApiResponse<TelefonoCorreoAspirante>>(
        `${this.api}/aspirantes/${id}/telefonos`,
        JSON.stringify(telefonos),
        this.httpOptionsJwt()
      )
      .pipe(
        map((response) => {
          if (response.exito) {
            this._notificationService.success(response.mensaje);
            return response;
          } else {
            this._notificationService.error(response.mensaje);
            throw new Error(response.mensaje);
          }
        }),
        catchError((error) => {
          this._notificationService.error(error.error.mensaje);
          return throwError(error);
        })
      );
  }

  obtenerDocumentacionAspirante(
    id: string
  ): Observable<ApiResponse<Array<DocumentosXAspirante>>> {
    return this._http
      .get<ApiResponse<Array<DocumentosXAspirante>>>(
        `${this.api}/aspirantes/${id}/documentacion`,
        this.httpOptionsJwt()
      )
      .pipe(
        map((response) => {
          if (response.exito) {
            return response;
          } else {
            this._notificationService.error(response.mensaje);
            throw new Error(response.mensaje);
          }
        }),
        catchError((error) => {
          console.log(error);
          this._notificationService.error(error.error.mensaje);
          return throwError(error);
        })
      );
  }

  actualizarTipoPropuesta(
    tipoPropuesta: TipoPropuestaAspirante,
    id: string
  ): Observable<ApiResponse<TipoPropuestaAspirante>> {
    return this._http
      .put<ApiResponse<TipoPropuestaAspirante>>(
        `${this.api}/aspirantes/${id}/tipo-propuesta`,
        JSON.stringify(tipoPropuesta),
        this.httpOptionsJwt()
      )
      .pipe(
        map((response) => {
          if (response.exito) {
            this._notificationService.success(response.mensaje);
            return response;
          } else {
            this._notificationService.error(response.mensaje);
            throw new Error(response.mensaje);
          }
        }),
        catchError((error) => {
          this._notificationService.error(error.error.mensaje);
          return throwError(error);
        })
      );
  }

  actualizarOtrosDatos(
    otroDato: OtrosDatosAspirante,
    id: string
  ): Observable<ApiResponse<OtrosDatosAspirante>> {
    return this._http
      .put<ApiResponse<OtrosDatosAspirante>>(
        `${this.api}/aspirantes/${id}/otrosDatos`,
        JSON.stringify(otroDato),
        this.httpOptionsJwt()
      )
      .pipe(
        map((response) => {
          if (response.result) {
            this._notificationService.success('Datos guardados con éxito.');
            return response;
          } else {
            this._notificationService.error(response.mensaje);
            throw new Error(response.mensaje);
          }
        }),
        catchError((error) => {
          this._notificationService.error(error.error.mensaje);
          return throwError(error);
        })
      );
  }

  subirArchivosExpediente(
    data: any,
    idDocumento: string,
    idAspirante: string
  ): Observable<ApiResponse<DocumentosXAspirante>> {
    return this._http
      .post<ApiResponse<DocumentosXAspirante>>(
        `${this.api}/aspirantes/${idAspirante}/documentos/${idDocumento}`,
        data,
        this.httpOptionsFilesJwt()
      )
      .pipe(
        map((response) => {
          if (response.exito) {
            return response;
          } else {
            this._notificationService.error(response.mensaje);
            throw new Error(response.mensaje);
          }
        }),
        catchError((error) => {
          console.log(error);
          this._notificationService.error(error.error.mensaje);
          return throwError(error);
        })
      );
  }

  public firmarURLArchivo(filePath: string): Observable<string> {
    return this._http.get<string>(
      `${this.api}/aspirantes/FirmarURLArchivo?filePath=${filePath}`,
      this.httpOptionsFilesJwt()
    );
  }

  obtenerPerfilCompleto(
    id: string
  ): Observable<ApiResponse<PerfilCompletoAspirante>> {
    return this._http
      .get<ApiResponse<PerfilCompletoAspirante>>(
        `${this.api}/aspirantes/${id}/perfil-completo`,
        this.httpOptionsJwt()
      )
      .pipe(
        map((response) => {
          if (response.exito) {
            return response;
          } else {
            this._notificationService.error(response.mensaje);
            throw new Error(response.mensaje);
          }
        }),
        catchError((error) => {
          if (error.status == 405) {
            this._notificationService.error(error.message);
          } else if (error.status === 422) {
            this._notificationService.error(error.error.mensaje);
          }
          console.log(error);
          return throwError(error);
        })
      );
  }

  obtenerOtrosDocumentos(
    id: string
  ): Observable<ApiResponse<OtrosDatosAspirante>> {
    return this._http
      .get<ApiResponse<OtrosDatosAspirante>>(
        `${this.api}/aspirantes/${id}/otrosDocumentos`,
        this.httpOptionsJwt()
      )
      .pipe(
        map((response) => {
          if (response.exito) {
            return response;
          } else {
            this._notificationService.error(response.mensaje);
            throw new Error(response.mensaje);
          }
        }),
        catchError((error) => {
          if (error.status == 405) {
            this._notificationService.error(error.message);
          } else if (error.status === 422) {
            this._notificationService.error(error.error.mensaje);
          }
          console.log(error);
          return throwError(error);
        })
      );
  }

  obtenerDocumentacionCompleta(
    id: string
  ): Observable<ApiResponse<DocumentosXAspirante[]>> {
    return this._http
      .get<ApiResponse<DocumentosXAspirante[]>>(
        `${this.api}/aspirantes/${id}/documentacion`,
        this.httpOptionsJwt()
      )
      .pipe(
        map((response) => {
          if (response.exito) {
            return response;
          } else {
            this._notificationService.error(response.mensaje);
            throw new Error(response.mensaje);
          }
        }),
        catchError((error) => {
          if (error.status == 405) {
            this._notificationService.error(error.message);
          } else if (error.status === 422) {
            this._notificationService.error(error.error.mensaje);
          }
          console.log(error);
          return throwError(error);
        })
      );
  }
}
